import { LoginService } from './core/services/authentication.service';
import { CrossTabAuthService } from './core/services/cross-tab-auth.service';
import { ErrorHandler, NgModule, inject, provideAppInitializer } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { VersionCheckService } from './core/services/version-check.service';
import { onBoardService } from './core/http/onBoardig/onBording.service';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { JwtInterceptor } from './core/services/interceptor/jwt.interceptor';
import { ErrorInterceptor } from './core/services/interceptor/error.interceptor';
import { SaveFeedbackInterceptor } from './core/services/interceptor/save-feedback.interceptor';
import { DatePipe } from '@angular/common';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AuthGuard } from './core/services/guards/auth.guard';
import { RoleGuardService } from './core/services/guards/role-guard.service';
import { StudentAuthGuard } from './core/services/guards/student.guard';
import * as Sentry from '@sentry/angular';
import { VersionCheckBarComponent } from './shared/components/version-check-bar/version-check-bar.component';
import { provideI18n } from './core/i18n/i18n.providers';
import { provideAppearance } from './core/theme/appearance.providers';
import { provideDesignSystem } from './ui/ui.providers';


@NgModule({
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    VersionCheckBarComponent,
  ],
  providers: [
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({
        showDialog: false,
      }),
    },
    DatePipe,
    onBoardService,
    LoginService,
    CrossTabAuthService,
    // Runs before the first route resolves: reconciles a dead local session and
    // registers the instant cross-tab logout listener.
    provideAppInitializer(() => inject(CrossTabAuthService).init()),
    AuthGuard,
    StudentAuthGuard,
    VersionCheckService,
    RoleGuardService,
    { provide: MatDialogRef, useValue: {} },
    { provide: MAT_DIALOG_DATA, useValue: {} },
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: SaveFeedbackInterceptor, multi: true },
    provideHttpClient(withInterceptorsFromDi()),
    provideI18n(),
    provideAppearance(),
    provideDesignSystem()
  ]
})
export class AppModule { }
